import { Component, ViewChild } from '@angular/core';
import {
  AppTableComponent,
  MessagesComponent,
  OpnSupplierListSaveModel,
  OpnSupplierListService,
  SearchModel,
  SearchResultModel,
  TranslationManager,
} from 'src/common';
import { SupplierModel, SuppliersService } from 'src/common/services/supplier';

@Component({
  selector: 'supplier-select',
  templateUrl: './supplier-select.component.html',
})
export class SupplierSelectComponent {
  constructor(private suppliersService: SuppliersService, private opnSupplierListService: OpnSupplierListService) { }

  @ViewChild('table') table: AppTableComponent;
  translationManager = TranslationManager;
  selectedIds: any[];
  resolve: any;
  suppliers: any[];
  show: boolean = false;
  requestId: number;

  showModal(requestId: number): Promise<boolean> {
    this.show = true;
    this.requestId = requestId;
    this.selectedIds = [];
    this.table.onSearch = this.doSearch.bind(this);
    this.table.search();

    return new Promise((resolve) => {
      this.resolve = resolve;
    });
  }

  doSearch(search: SearchModel) {
    this.suppliersService
      .searchForOpnSupplierList(search, this.requestId)
      .then((result: SearchResultModel<SupplierModel>) => {
        this.suppliers = result.items;
        this.table.setTotalCount(result.totalCount);
      });
  }

  selectSupplier(id: number, event) {
    if (event.target.checked) {
      this.selectedIds.push(id);
    }
    else {
      this.selectedIds.forEach((element, index) => {
        if (element == id) this.selectedIds.splice(index, 1);
      });
    }
  }

  close() {
    this.show = false;
    if (this.resolve) {
      this.resolve(false);
    }
  }

  submit() {
    if (this.selectedIds.length == 0) {
      MessagesComponent.instance.showError([this.translationManager.getTranslation('Морате изабрати добављача')]);
    }
    else {
      this.save();
    }
  }

  save() {
    let model: OpnSupplierListSaveModel = new OpnSupplierListSaveModel();
    model.requestId = this.requestId;
    model.selectedIds = this.selectedIds;

    this.opnSupplierListService.save(model).then(() => {
      this.show = false;
      if (this.resolve) {
        this.resolve(true);
      }
    });
  }

  checkSupplierId(id: number): boolean {
    if (this.selectedIds.includes(id)) {
      return true;
    }
    return false;
  }
}
